var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.484 0 0 4.484 0 10s4.484 10 10 10 10-4.484 10-10S15.516 0 10 0z",
    fill: "#D0393E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.836 6.629a.627.627 0 0 1 0 .883l-5.86 5.86a.624.624 0 0 1-.882 0l-2.93-2.93a.627.627 0 0 1 0-.883.627.627 0 0 1 .883 0l2.488 2.488 5.418-5.418a.62.62 0 0 1 .883 0z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.e46e5ec921400adca5c3e809417e6562.svg";
export { ForwardRef as ReactComponent };